import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async getRemainingBudgetList(adsId) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/payment/remain-budget-list`,
      { adsId },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getAVGUsage(adsId) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/payment/avg-usage`,
      { adsId },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async getPaymentHistory(adsId, accountType) {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/payment/history`,
      { adsId, accountType },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
